import { createRoute, redirect } from '@tanstack/react-router';

import { queryClient } from 'pages/root-page';

import { ensureAuthInfo } from 'entities/auth';

import { rootRoute } from '../root';

export const AuthenticatedRoute = createRoute({
  getParentRoute: () => rootRoute,
  id: 'authenticated',
  beforeLoad: async () => {
    if (!(await ensureAuthInfo(queryClient))) throw redirect({ to: '/auth' });
  },
});
